import { AnyObject } from '../types'
import omitBy from 'lodash/omitBy'

type PreapreDataType = <T extends AnyObject>(data?: T) => Partial<T> | undefined

export const prepareData: PreapreDataType = data => {
	return data
		? (omitBy(data, value => value == null || value === '') as typeof data)
		: undefined
}
